export default {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    // 聚焦元素
    el.focus()
  }
  // 不能使用更新时聚焦input框，因为很多的表单操作都会导致触发这个钩子，从而引发异常光标聚焦
  // update: function (el) {
  //   // 聚焦元素
  //   el.focus()
  // }
}



// WEBPACK FOOTER //
// ./src/directive/focus/index.js